import styles from './BankingIngestionLine.module.scss';
import PillArrowGlyph from '../PillArrowGlyph/PillArrowGlyph';
import { REVIEW_NOW_LABEL } from './constants';

export interface IngestionNoun {
    singular: string;
    plural: string;
}

const BANK_STATEMENT_NOUN: IngestionNoun = { singular: 'bank statement', plural: 'bank statements' };

interface BankingIngestionLineProps {
    /** From `getBankingPendingStatus`, the same fetch `store/banking` already makes. */
    failedCount: number;
    onReviewClick: () => void;
    /** What is being counted; bank statements unless a caller says otherwise. */
    noun?: IngestionNoun;
}

/** "N bank statements not ingested. Review Now" beside a tab title; nothing when N is 0. */
const BankingIngestionLine = ({ failedCount, onReviewClick, noun = BANK_STATEMENT_NOUN }: BankingIngestionLineProps) => {
    if (!failedCount) return null;

    const text = `${failedCount} ${failedCount !== 1 ? noun.plural : noun.singular} not ingested.`;

    return (
        <div className={styles.Line} role="alert">
            <span className={styles.Text} title={text}>
                {text}
            </span>{' '}
            <button className={styles.ReviewLink} onClick={onReviewClick}>
                {REVIEW_NOW_LABEL}
                <PillArrowGlyph className={styles.ReviewIcon} />
            </button>
        </div>
    );
};

export default BankingIngestionLine;
